import React from "react";
import { Container, Col, Form, Row, Button, Alert, Overlay, Spinner } from "react-bootstrap";
import TopNavBar from "../Components/TopNavBar";
import ContentBlock from "../Components/ContentBlock";
import Footer from "../Components/Footer";
import { getCartItems, getCartTotal, updateCartQuantity, getUser, isLoggedIn, setUser } from "../Session/Session";
import CartItemReadOnly from "../Components/CartItemReadOnly";
import PayseraPaymentService from "../Api/PayseraPaymentService";
import OrdersService from "../Api/OrdersService";
import ClassifiersService from "../Api/ClassifiersService";
import LoginService from "../Api/LoginService";
import { faL } from "@fortawesome/free-solid-svg-icons";

class PaymentPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageName: "Apmokėjimas",
            cartItems: getCartItems(),
            cartTotal: getCartTotal(),
            user: getUser(),
            isLoggedIn: isLoggedIn() ? true : false,
            countries: [],
            orderCreated: false,
            showAlert: true,
            firstName:"",
            lastName:"",
            email:"",
            phone:"",
            address:"",
            city:"",
            postcode:""
        };

        this.updateCartTotal = this.updateCartTotal.bind(this);
        this.getCountries = this.getCountries.bind(this);
        this.createOrder = this.createOrder.bind(this);
        this.redirectToPaysera = this.redirectToPaysera.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.getUserInfo();
        this.setState({
            cartItems: getCartItems(),
            cartTotal: getCartTotal(),
            user: getUser(),
            firstName: this.state.user.firstName,
            lastName: this.state.user.lastName,
            email: this.state.user.email,
            phone: this.state.user.phone,
            address: this.state.user.address,
            city: this.state.user.city,
            postcode: this.state.user.postcode
        });

        this.getCountries();
    }

    getUserInfo = () => {
        LoginService.getUserInfo()
            .then(response => {
                setUser(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    updateCartTotal = (id, quantity) => {
        var item = this.state.cartItems.find(x => x.id === id);
        item.quantity = quantity;
        updateCartQuantity(id, quantity);

        this.setState({
            cartTotal: getCartTotal(),
        });
    }

    getCountries = () => {
        ClassifiersService.getClassifier('countries')
            .then(response => {
                this.setState({
                    countries: response.data,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }


    redirectToPaysera = () => {
        PayseraPaymentService.createPayment(this.state.cartTotal, this.state.user.email)
            .then(response => {
                console.log(response.data.url);
                window.location.href = response.data.url;
            })
            .catch(error => {
                console.log(error);
            });
    }

    createOrder = () => {
        var order = {};
        order["cartTotal"] = this.state.cartTotal;
        order["Items"] = this.state.cartItems;

        

        OrdersService.createOrder(order)
            .then(response => {
                console.log(response);
                //this.redirectToPaysera();
            })
            .catch(error => {
                console.log(error);
            });
    }

    hideAlert = () => {
        this.setState({
            showAlert: false,
        });
    }




    render() {
        const pageStyle = {
            backgroundImage: "url(renginiai-page-background.jpg)",
            height: "100vh",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
        };

        var buyerDataIsSet = this.state.firstName !== "" && this.state.lastName !== "" && this.state.email !== "" && this.state.phone !== "" && this.state.address !== "";
        var paymentBtnAlt = buyerDataIsSet ? "Apmokėti" : "Užpildykite duomenis";

        return (
            <Container fluid style={pageStyle}>
                <TopNavBar activeRoute={3} />
                <Container>
                    <h1 className="page-title">{this.state.pageName}</h1>
                    <ContentBlock>
                        <Row>
                            <Alert 
                                variant="dark" 
                                className="mb-3" 
                                dismissible 
                                style={{opacity:0.8}} 
                                show={this.state.showAlert} 
                                onClose={this.hideAlert}>
                                <p>
                                    Norėdami apmokėti, užpildykite duomenis ir paspauskite mygtuką "Mokėti dabar".
                                </p>
                            </Alert>
                        </Row>
                        <Row>
                            <Col xs={12} md={6} lg={6}>
                                <Row className="mb-3">
                                    <Form.Group as={Col}>
                                        <Form.Text className="text-muted">Vardas</Form.Text>
                                        <Form.Control type="text" onChange={this.handleInputChange} placeholder="Vardas" value={this.state.firstName ?? ""} name="firstName" />
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Text className="text-muted">Pavardė</Form.Text>
                                        <Form.Control type="text" onChange={this.handleInputChange} placeholder="Pavardė" value={this.state.lastName ?? ""} name="lastName" />
                                    </Form.Group>
                                </Row>
                                <Row className="mb-3">
                                    <Form.Group as={Col}>
                                        <Form.Text className="text-muted">El. paštas</Form.Text>
                                        <Form.Control type="text" onChange={this.handleInputChange} placeholder="El. paštas" value={this.state.email ?? ""} name="email"/>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Text className="text-muted">Telefono numeris</Form.Text>
                                        <Form.Control type="text" onChange={this.handleInputChange} placeholder="Telefono numeris" value={this.state.phone ?? ""} name="phone"/>
                                    </Form.Group>
                                </Row>
                                <Form.Group className="mb-3">
                                    <Form.Text className="text-muted">Pristatymo adresas</Form.Text>
                                    <Form.Control type="text" onChange={this.handleInputChange} placeholder="Pristatymo adresas" value={this.state.address ?? ""} name="address" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Text className="text-muted">Miestas</Form.Text>
                                    <Form.Control type="text" onChange={this.handleInputChange} placeholder="Miestas" name="city" value={this.state.city ?? ""} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Text className="text-muted">Pašto kodas</Form.Text>
                                    <Form.Control type="text" onChange={this.handleInputChange} placeholder="Pašto kodas" name="postcode" value={this.state.postcode ?? ""} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Text className="text-muted">Šalis</Form.Text>
                                    <Form.Select aria-label="Pasirinkite šalį" name="country">
                                        <option>Pasirinkite šalį</option>
                                        {this.state.countries.map((item, index) => {
                                            return <option key={index} value={item.id} className="select-option-item">{item.Name}</option>
                                        })}
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Text className="text-muted" name="notes">Komentaras</Form.Text>
                                    <Form.Control type="text" placeholder="Komentaras" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Text className="text-muted">Consent (Privacy Policy)</Form.Text>
                                    <Form.Check type="checkbox" label="Sutinku su privatumo politika" name="consent" onClick={this.handleInputChange} checked={this.state.consent ?? false}/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                {this.state.cartItems.map((item, index) => {
                                    return <CartItemReadOnly
                                        Id={item.id}
                                        Name={item.name}
                                        Price={item.price}
                                        Image={item.image ?? ''}
                                        Quantity={item.quantity}
                                        key={index}
                                    />
                                })
                                }
                                <Row>
                                    <Col xs={6} md={6} lg={6}>
                                        <Form.Control type="text" placeholder="Nuolaidos kodas" className="mt-2" />
                                        <Form.Text className="text-muted"> Įveskite nuolaidos kodą </Form.Text>
                                        <Form.Control type="submit" value="Pritaikyti" className="mt-2 btn btn-outline-light" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <h3 className='text-right mt-2'>Iš viso: {this.state.cartTotal} €</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>
                                        <Button
                                            variant="outline-light"
                                            className="mb-3"
                                            onClick={this.redirectToPaysera}
                                            disabled={this.state.email !== "" && this.state.consent === true && this.state.phone !== "" && this.state.address !== "" && this.state.city !== "" && this.state.postcode !== "" && this.state.country !== "" ? false : true}
                                        >
                                            Mokėti dabar
                                        </Button>
                                        <Overlay>

                                        </Overlay>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </ContentBlock>
                </Container>
                <Footer></Footer>
            </Container>
        );
    }

}

export default PaymentPage;